import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ICellRendererAngularComp } from 'ag-grid-angular';

import { BaseRendererComponent } from '../base-renderer/base-renderer.component';
import { LabelValue } from '../../../../models';

@Component({
  selector: 'app-select-renderer',
  templateUrl: './select-renderer.component.html',
  styleUrl: './select-renderer.component.scss',
  imports: [NgSelectComponent, FormsModule, AsyncPipe],
})
export class SelectRendererComponent extends BaseRendererComponent implements ICellRendererAngularComp {
  public onChange(model: LabelValue) {
    this.params.node.setDataValue(this.colId, model.value);
  }
}
